import React from 'react';
import JobList from './JobList';

const EmployerMyJobs = () => {
    return (
        <div>
            <JobList/>
        </div>
    );
};

export default EmployerMyJobs;